<template>
  <el-dialog
    :title="$t('deleteMapping.title')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('deleteMapping.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteMapping.cancel') }}</el-button>
      <el-button type="primary" @click="deleteMapping">{{ $t('deleteMapping.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMapping } from '@/api/dev/mappingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteMapping',
  data() {
    return {
      dialogVisible: false,
      mappingInfo: {}
    }
  },
  methods: {
    open(mapping) {
      this.mappingInfo = { ...mapping }
      this.dialogVisible = true
    },
    handleClose() {
      this.mappingInfo = {}
    },
    deleteMapping() {
      const params = {
        ...this.mappingInfo,
        shopId: getShopId()
      }
      deleteMapping(params).then(() => {
        this.$message.success(this.$t('deleteMapping.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      }).catch(error => {
        this.$message.error(error.message)
      })
    }
  }
}
</script>